module.exports = __webpack_public_path__ + "media/images/cplook/careerplug_white_logo_only-c142209ed88366510e4fc9b2f4341bab.png";